export default [
    'top-left', 'top-right', 'top-center', 'bottom-left', 'bottom-right', 'bottom-center',
];



// WEBPACK FOOTER //
// ./resources/js/components/enso/bulma/toastr/config/positions.js